module.exports = __webpack_public_path__ + "static/media/BG.3ba6ff6b.svg";